(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('click', async function(event) {
  var trigger = event.target.closest('[data-regung-cookie-preferences]');
  if (!trigger) return;
  var status = document.getElementById('regung-cookie-status');
  var english = document.documentElement.lang.toLowerCase().indexOf('en') === 0;
  status.textContent = english ? 'Opening cookie settings …' : 'Cookie-Einstellungen werden geöffnet …';
  status.hidden = false;
  try {
    if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') throw new Error('Cookie preferences unavailable');
    await window.privacyBanner.showPreferences();
    status.hidden = true;
  } catch (error) {
    status.textContent = english ? 'Cookie settings could not be opened. Please reload the page and try again.' : 'Die Cookie-Einstellungen konnten gerade nicht geöffnet werden. Bitte lade die Seite neu und versuche es erneut.';
    status.hidden = false;
  }
}, true);

  } catch(e) { console.error(e); }
})();
})();
